<template>
  <div>
    <div class="back" @click="goBack">&lt; 返 回</div>
    <div class="common-style addBook">
      <a-form id="add" :form="form" ref="formbook">
        <a-form-item v-bind="formItemLayout" label="学段">
          <a-select
            v-model="modelForm.stageName"
            :defaultValue="modelForm.stageName"
            @change="changeStages"
          >
            <a-select-option v-for="(item, index) in stagesList" :key="index" :value="index">
              <span v-if="index != 0">{{ item }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="学科">
          <a-select
            v-model="modelForm.subjectName"
            :defaultValue="modelForm.subjectName"
            @change="changeSubjects"
          >
            <a-select-option v-for="(item, index) in subjectsList" :key="index" :value="index">
              <span v-if="index != 0">{{ item }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="教材版本">
          <a-select
            @change="changeVersions"
            v-model="modelForm.versionName"
            :defaultValue="modelForm.versionName"
          >
            <a-select-option
              v-for="(item, index) in versionsList"
              :key="index"
              :value="index"
            >{{ item }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="年级">
          <a-select
            @change="changeGrades"
            v-model="modelForm.gradeName"
            :defaultValue="modelForm.gradeName"
          >
            <a-select-option
              v-for="(item, index) in gradesList"
              :key="index"
              :value="index"
            >{{ item }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="课本名称">
          <a-input v-model="formDate.name" />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="封面图片">
          <a-upload
            name="request"
            style="width:105px;"
            listType="picture-card"
            class="avatar-uploader"
            accept="image/jpeg, image/png"
            :beforeUpload="checkImg"
            :headers="upload.headers"
            :showUploadList="false"
            :customRequest="ImgUpload"
          >
            <img
              v-if="imageUrl || coverFullUrl"
              :src="imageUrl || coverFullUrl"
              alt="avatar"
              style="width:110px;height:100px;"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">选择图片</div>
            </div>
          </a-upload>
          <p style="color:#999;">建议尺寸：180*160(px)</p>
        </a-form-item>

        <a-form-item v-bind="formItemLayout" label="选择文档">
          <a-upload
            name="request"
            :multiple="false"
            accept="application/pdf"
            :beforeUpload="checkPdfFile"
            :headers="upload.headers"
            :fileList="fileList"
            :remove="removeFile"
            :customRequest="FileUpload"
          >
            <a-button>
              <a-icon type="upload" />上传文件
            </a-button>
          </a-upload>
          <p>支持扩展名为.pdf的文件&nbsp;&nbsp;&nbsp;</p>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="选择目录">
          <a-upload
            name="request"
            :multiple="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :beforeUpload="checkCatalog"
            :headers="upload.headers"
            :fileList="catalogList"
            :remove="removeCatalog"
            :customRequest="CatalogUpload"
          >
            <a-button>
              <a-icon type="upload" />上传文件
            </a-button>
          </a-upload>
          <p>
            支持扩展名为.xlsx, .xls 的文件&nbsp;&nbsp;&nbsp;
            <a
              href="/template/directory.xlsx"
              style="font-size:14px"
              download="directory.xlsx"
            >下载模板</a>
          </p>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
          <a-button
            type="primary"
            @click="createBook()"
            :style="{ margin: '0 50px 0 0' }"
            v-if="!saveType"
            :disabled="isDisabled"
          >创建课本</a-button>
          <a-button
            type="primary"
            @click="editBook()"
            :style="{ margin: '0 50px 0 0' }"
            v-if="saveType"
            :disabled="isDisabled"
          >保存课本</a-button>
          <a-button type="danger" @click="deleteBook()" v-if="saveType">删除课本</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers"
import $upload from "../../utils/upload"
export default {
  data () {
    return {
      publicPath: process.env.VUE_APP_BASE_API,
      modifyList: {}, // 编辑的原数据
      formDate: {}, // 提交的表单数据
      saveType: false, // 编辑or添加
      // 上传文件的头
      upload: {
        root: process.env.VUE_APP_BASE_API,
        headers: { authorization: this.$store.getters.token },
      },
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 12 },
      },
      stagesList: [], //学段下拉数组
      subjectsList: [], //学科下拉数组
      versionsList: [], //版本下拉数组
      gradesList: [], //年级下拉数组
      loading: false,
      imageUrl: "", // 上传的封面
      coverFullUrl: "", // 编辑状态下的原有的封面
      modelForm: {
        stageName: "",
        subjectName: "",
        versionName: "",
        gradeName: "",
      },
      isDisabled: false, // 按钮是否禁用
      fileList: [], //上传的文件列表
      catalogList: [], //上传的文件列表
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    async ImgUpload (data) {
      this.loading = true
      var type = ['.jpeg', '.jpg', '.png']
      var res = await $upload(data, type, 2, 10000)
      this.loading = false
      console.log('====打印res', res)
      if (res.code == 200) {
        this.imageUrl = res.fullReadPath // 完整路径展示图片
        this.formDate.coverurl = res.partPath // 不完整路径提交表单
      } else {
        this.$message.error(res.message, 1)
      }
    },
    async FileUpload (data) {
      var type = ['.pdf']
      var res = await $upload(data, type, 50, 60000)
      console.log('====打印res', res)
      if (res.code == 200) {
        this.fileList = []
        this.fileList.push(res)
        this.formDate.bookurl = res.partPath
      } else {
        this.$message.error(res.message, 1)
      }
    },
    async CatalogUpload (data) {
      var type = ['.xlsx', '.xls']
      var res = await $upload(data, type, 20, 60000)
      console.log('====打印res', res)
      if (res.code == 200) {
        this.catalogList = []
        this.catalogList.push(res)
        this.formDate.dirurl = res.partPath
      } else {
        this.$message.error(res.message, 1)
      }
    },
    // 根据this.$route.query.type判断编辑还是新建
    editOrCreate () {
      // console.log(this.$route.query.type)
      if (this.$route.query.type == true) {
        //编辑课本
        this.saveType = true
        this.modifyList = JSON.parse(this.$route.query.books)
        // console.log(this.modifyList)
        this.coverFullUrl = this.modifyList.readCoverUrl
        console.log(this.coverFullUrl)
        this.formDate = {
          elecbookid: this.modifyList.id, // 课本id
          stageid: this.modifyList.stageid, //学段id
          subjectid: this.modifyList.subjectid, //学科id
          textbookversionid: this.modifyList.textbookVersionid, //版本id
          gradeid: this.modifyList.gradeid, //年级id
          orgid: this.modifyList.orgid, // 组织id
          name: this.modifyList.name, //课本名称
          coverurl: this.modifyList.coverurl, // 封面URL不完整路径
          bookurl: this.modifyList.bookurl, //文件URL
          dirurl: this.modifyList.dirurl, //目录URL
        }
      } else {
        // 新建课本
        this.saveType = false
        this.formDate = {
          stageid: "", //学段当前选中项
          subjectid: "", //学科当前选中项
          textbookversionid: "", //版本当前选中项
          gradeid: "", //年级当前选中项
          orgid: this.$store.getters.orgid, // 操作人组织id
          name: "", //课本名称
          coverurl: "", // 封面URL
          bookurl: "", //文档url
          dirurl: "", //目录URL
        }
      }
      // 获取学段联动数据
      this.$nextTick(() => {
        this.getAllselect()
      })
    },
    // 学段联动接口
    getAllselect () {
      this.$http
        .get("v1/learnonly/teachingAssistant/showVerGreSubSta", {
          params: {
            userid: this.$store.getters.id,
            stageid: this.formDate.stageid,
            subjectid: this.formDate.subjectid,
          },
        })
        .then((response) => {
          //   console.log(response);

          this.stagesList = response.data.stage
          this.subjectsList = response.data.subject
          this.versionsList = response.data.versions
          this.gradesList = response.data.grade
          console.log(this.stagesList)
          console.log(this.subjectsList)
          console.log(this.versionsList)
          if (this.$route.query.type == true) {
            console.log(1)
            setTimeout(() => {
              if (this.formDate.stageid && this.stagesList) {
                for (let [k, i] of Object.entries(this.stagesList)) {
                  if (k == this.formDate.stageid) {
                    this.modelForm.stageName = i
                  }
                }
              }
            }, 500)
          }
          if (this.$route.query.type == true) {
            // console.log(this.subjectsList)
            // console.log(this.formDate)
            setTimeout(() => {
              if (this.subjectsList && this.formDate.subjectid) {
                for (let [k, i] of Object.entries(this.subjectsList)) {
                  if (k == this.formDate.subjectid) {
                    this.modelForm.subjectName = i
                  }
                }
              }
            }, 500)
          }
          if (this.$route.query.type == true) {
            setTimeout(() => {
              if (this.versionsList && this.formDate.textbookversionid) {
                for (let [k, i] of Object.entries(this.versionsList)) {
                  if (k == this.formDate.textbookversionid) {
                    this.modelForm.versionName = i
                  }
                }
              }
            }, 500)
          }
          if (this.$route.query.type == true) {
            setTimeout(() => {
              // console.log(this.gradesList)
              // console.log(this.formDate)
              if (this.gradesList && this.formDate.gradeid) {
                for (let [k, i] of Object.entries(this.gradesList)) {
                  if (k == this.formDate.gradeid) {
                    this.modelForm.gradeName = i
                  }
                }
              }
            }, 500)
          }
        })
    },
    changeStages (value) {
      //   console.log(value);

      this.formDate.stageid = value
      this.getAllselect()
    },
    changeSubjects (value) {
      //   console.log(value);

      this.formDate.subjectid = value
      this.getAllselect()
    },
    changeVersions (event) {
      this.formDate.textbookversionid = event
      this.getAllselect()
    },
    changeGrades (event) {
      this.formDate.gradeid = event
      this.getAllselect()
    },
    // 检查图片格式
    checkImg (file) {
      // console.log(file.type)
      if (file.type == "image/jpeg" || file.type == "image/png") {
        return true
      } else {
        this.$message.warn("请上传img或者png格式图片!")
        return false
      }
    },
    // 检查文档pdf格式
    checkPdfFile (file) {
      const isPDF = file.type === "application/pdf"
      if (!isPDF) {
        this.$message.error("请上传pdf格式文件!")
        console.log(this.formDate)
      }
      return isPDF
    },
    // 检查目录excel格式
    checkCatalog (file) {
      const isEXCEL =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel"
      if (!isEXCEL) {
        this.$message.error("请上传pdf格式文件!")
        console.log(this.formDate)
      }
      return isEXCEL
    },
    // 上传封面图片
    handleChange (info) {
      console.log(info)
      if (info.file.status === "uploading") {
        this.loading = true
      }
      if (info.file.status === "done") {
        this.loading = false
        this.imageUrl = info.file.response.fullReadPath // 完整路径展示图片
        this.formDate.coverurl = info.file.response.partPath // 不完整路径提交表单
      }
    },
    // 上传文档
    uploadFileChange (info) {
      console.log(info)
      if (info.file.type == "application/pdf") {
        // 文档列表限制为1
        let fileList = [...info.fileList]
        fileList = fileList.slice(-1)
        this.fileList = fileList
      } else {
        // 格式不正确时 列表不显示
        this.fileList = []
      }
      if (info.file.status === "uploading") {
        this.loading = true
      }
      if (info.file.status === "done") {
        this.loading = false
        this.formDate.bookurl = info.file.response.partPath
      }
    },
    // 上传目录
    uploadCatalogChange (info) {
      console.log(info)
      if (
        info.file.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        info.file.type == "application/vnd.ms-excel"
      ) {
        // 格式正确时 目录列表限制为1
        let catalogList = [...info.fileList]
        catalogList = catalogList.slice(-1)
        this.catalogList = catalogList
      } else {
        // 格式不正确时 列表不显示
        this.catalogList = []
      }
      if (info.file.status === "uploading") {
        this.loading = true
      }
      if (info.file.status === "done") {
        this.loading = false
        this.formDate.dirurl = info.file.response.partPath
      }
    },
    // 移除已上传的文档
    removeFile () {
      this.$message.warn("已删除文档，请重新上传!")
      this.formDate.bookurl = ""
      this.fileList = []
    },
    // 移除已上传的目录
    removeCatalog () {
      this.$message.warn("已删除文档，请重新上传!")
      this.formDate.dirurl = ""
      this.catalogList = []
      console.log(this.formDate)
    },
    // 创建课本
    async createBook () {
      if (this.formDate.stageid == "") {
        this.$message.error("请选择学段")
        return
      }
      if (this.formDate.subjectid == "") {
        this.$message.error("请选择学科")
        return
      }
      if (this.formDate.textbookversionid == "") {
        this.$message.error("请选择版本")
        return
      }
      if (this.formDate.gradeid == "") {
        this.$message.error("请选择年级")
        return
      }
      if (this.formDate.name == "") {
        this.$message.error("请填写课本名称")
        return
      }
      if (this.formDate.coverurl == "") {
        this.$message.error("请上传图片")
        return
      }
      if (this.formDate.bookurl == "") {
        this.$message.error("请上传文档")
        return
      }
      if (this.formDate.dirurl == "") {
        this.$message.error("请上传目录")
        return
      }
      this.isDisabled = true
      var res = await this.$http.post(`v1/elecbook/elecbook`, this.formDate)
      if (res.data.code === 200) {
        // this.isDisabled = false
        this.$message.success("新建课本成功！")
        setTimeout(() => {
          this.$router.push({
            path: "/textbook/textbookList",
          })
        }, 1000)
      } else {
        this.isDisabled = false
        this.$message.error("创建课本失败！")
      }
    },
    // 保存课本
    async editBook () {
      this.isDisabled = true
      console.log(this.formDate)
      if (this.formDate.stageid == "") {
        this.$message.error("请选择学段")
        return
      }
      if (this.formDate.subjectid == "") {
        this.$message.error("请选择学科")
        return
      }
      if (this.formDate.textbookversionid == "") {
        this.$message.error("请选择版本")
        return
      }
      if (this.formDate.gradeid == "") {
        this.$message.error("请选择年级")
        return
      }
      if (this.formDate.name == "") {
        this.$message.error("请填写课本名称")
        return
      }
      var res = await this.$http.put(`v1/elecbook/elecbook`, this.formDate)
      console.log(res)
      if (res.data.code == 200) {
        this.isDisabled = false
        this.$message.success("保存课本成功！")
        setTimeout(() => {
          this.$router.push({
            path: "/textbook/textbookList",
          })
        }, 1000)
      } else {
        this.isDisabled = false
        this.$message.warning("保存课本失败！")
      }
    },
    // 删除课本
    deleteBook () {
      var _this = this
      this.$confirm({
        title: "确认删除该课本吗？",
        content: "删除后将无法恢复。",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk () {
          _this.$http
            .put("v1/elecbook/elecbookstate", {
              elecbookid: _this.modifyList.id,
              state: 1,
            })
            .then((res) => {
              console.log(res)
              if (res.data.code == 200) {
                _this.$message.success("删除成功！")
                setTimeout(() => {
                  _this.$router.push({
                    path: "/textbook/textbookList",
                  })
                })
              } else {
                _this.$message.error("删除失败！")
              }
            })
        },
        onCancel () {
          console.log("已取消！")
        },
      })
    },
    goBack () {
      window.history.go(-1)
    },
  },
  mounted () {
    // this.formDate.stageId = this.$store.getters.stageMessage.stageids
    //     ? this.$store.getters.stageMessage.stageids[0]
    //     : 0;
    // this.formDate.subjectId = this.$store.getters.stageMessage.subjectids
    //     ? this.$store.getters.stageMessage.subjectids[0]
    //     : 0;
    if (this.$store.getters.stageInfoList.length > 0) {
      this.formDate.stageId = this.$store.getters.stageInfoList[0].stageid
      if (this.$store.getters.stageInfoList[0].subjectids.length > 0) {
        this.formDate.subjectId = this.$store.getters.stageInfoList[0].subjectids[0]
      }
    }
    this.editOrCreate() //新增还是编辑
  },
}
</script>

<style>
.addBook {
  padding: 25px;
}
#add .dropbox {
  height: 180px;
  line-height: 1.5;
}
</style>
